import { Box } from '@mui/material';
import type { Job } from '../types/jobs.types';
import JobCard from './JobCard';

interface JobsListProps {
  jobs: Job[];
}

export default function JobsList({ jobs }: JobsListProps) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {jobs.map((job) => (
        <JobCard key={job.jobId} job={job} />
      ))}
    </Box>
  );
}
